import axios from '../request/http';


const finance = {
    // 提现列表
    getFinanceList(params) {
        return axios.get("/admin/cash/list", {params});
    },
    // 微信提现
    cashAccept(data) {
        return axios.post("/admin/cash/accept", data);
    },
    // 拒绝提现
    cashReject(data) {
        return axios.post("/admin/cash/reject", data);
    }
}

export default finance;


// WEBPACK FOOTER //
// ./src/api/finance.js